export interface GiftUserSummary {
  assignmentId?: string;
  userId: string;
  name?: string;
  phone?: string;
  storeId?: string;
  storeName?: string;
  assignedAt?: string;
  redeemedAt?: string;
}

export interface GiftStoreAllocation {
  storeId: string;
  storeName: string;
  totalQuantity: number;
  availableQuantity: number;
  assignedCount: number;
  usedQuantity: number;
}

export interface GiftResetConfig {
  enabled: boolean;
  dailyResetHour: number;
  dailyResetMinute: number;
  lastResetAt?: string;
}

export interface Gift {
  id: string;
  name: string;
  description?: string;
  imageUrl?: string;
  isActive?: boolean;
  storeAllocations?: GiftStoreAllocation[];
  resetConfig?: GiftResetConfig;
  totalQuantity: number;
  availableQuantity: number;
  assignedCount: number;
  usedQuantity: number;
  assignedUsers?: GiftUserSummary[];
  redeemedUsers?: GiftUserSummary[];
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateGiftPayload {
  name: string;
  description?: string;
  isActive?: boolean;
  storeAllocations?: GiftStoreAllocation[];
  resetConfig?: GiftResetConfig;
}

export interface UpdateGiftPayload {
  name?: string;
  description?: string;
  isActive?: boolean;
  storeAllocations?: GiftStoreAllocation[];
  resetConfig?: GiftResetConfig;
}

export interface GiftAssignment {
  assignmentId: string;
  giftId: string;
  userId: string;
  storeId?: string;
  storeName?: string;
  status: 'assigned' | 'redeemed';
  assignedAt: string;
  redeemedAt?: string;
  qrTarget: string;
  qrQuery?: string;
  qrCode?: string;
  userInfo?: {
    name?: string;
    phone?: string;
    [key: string]: any;
  };
  metadata?: {
    [key: string]: any;
  };
}

export interface AssignGiftPayload {
  giftId: string;
  userId: string;
  storeId: string;
  storeName?: string;
  userInfo?: {
    name?: string;
    phone?: string;
    [key: string]: any;
  };
  metadata?: {
    [key: string]: any;
  };
}

export interface RedeemGiftPayload {
  assignmentId: string;
  giftId?: string;
  userId?: string;
  storeId?: string;
}

export interface GiftAssignmentQRResponse {
  assignmentId: string;
  status: 'assigned' | 'redeemed';
  storeId?: string;
  storeName?: string;
  qrTarget: string;
  qrQuery?: string;
  qrCode: string;
}

export interface RedeemGiftResponse {
  message: string;
  assignment: GiftAssignment;
  giftId: string;
}

export interface GiftResetResult {
  giftId: string;
  applied: boolean;
  resetAt?: string;
  reason?: string;
  error?: string;
}

export interface ManualResetGiftResponse {
  message: string;
  giftId: string;
  applied: boolean;
  resetAt?: string;
  reason?: string;
}

export interface ManualResetAllResponse {
  message: string;
  processed: number;
  applied: number;
  skipped: number;
  failed: number;
  results: GiftResetResult[];
}

export const isGiftActive = (gift?: Pick<Gift, 'isActive'> | null): boolean => gift?.isActive !== false;

